// ============================================================================
// BINARY SEARCH - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'binary-search',
  name: 'Binary Search',
  category: 'Search',
  complexity: {
    time: 'O(log n)',
    space: 'O(1)'
  },
  description: 'Binary Search is an efficient algorithm for finding an item from a sorted list of items by repeatedly dividing the search interval in half.'
};
export type MetaType = typeof meta;
